import { render, staticRenderFns } from "./ios-take-down.vue?vue&type=template&id=42272fc2&scoped=true"
import script from "./ios-take-down.vue?vue&type=script&lang=js"
export * from "./ios-take-down.vue?vue&type=script&lang=js"
import style0 from "./ios-take-down.vue?vue&type=style&index=0&id=42272fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42272fc2",
  null
  
)

export default component.exports